import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const roles = [
  { v: "team_parent", l: "Team Parent" },
  { v: "scorekeeper", l: "Scorekeeper" },
  { v: "field_prep", l: "Field Prep" },
  { v: "fundraising", l: "Fundraising" },
  { v: "event_support", l: "Event Support" },
  { v: "service", l: "Service Project" },
];

export default function Volunteer() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ role: "team_parent", event_id: "", notes: "" });
  const load = () => api.get("/volunteer").then((r) => setItems(r.data));
  useEffect(load, []);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/volunteer", { ...form, name: user.name });
      toast.success("Signed up!"); setForm({ role: "team_parent", event_id: "", notes: "" }); load();
    } catch { toast.error("Failed"); }
  };
  return (
    <div data-testid="volunteer-page">
      <div className="eyebrow mb-1">Volunteer</div>
      <h1 className="font-display text-3xl uppercase mb-6">Sign Up To Help</h1>
      <div className="grid lg:grid-cols-[1fr_350px] gap-5">
        <div className="space-y-3">
          {items.map((v) => (
            <div key={v.id} className="kr-card rounded-xl p-4 flex justify-between">
              <div>
                <div className="font-semibold">{v.name}</div>
                <div className="text-xs text-slate-400">{v.notes || ""}</div>
              </div>
              <span className="text-[10px] uppercase tracking-widest text-[#00E5FF]">{v.role.replace("_", " ")}</span>
            </div>
          ))}
          {items.length === 0 && <p className="text-slate-500">No signups yet — be the first!</p>}
        </div>
        <form onSubmit={submit} className="kr-card rounded-xl p-5 space-y-3 h-fit">
          <div className="eyebrow">Sign Up</div>
          <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-2">
            {roles.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
          </select>
          <textarea placeholder="Notes (event date, availability...)" rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-2" />
          <button className="btn-primary w-full justify-center">Sign Up</button>
        </form>
      </div>
    </div>
  );
}
